import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  areCookiesAccepted,
  areCookiesRejected,
  setAllowCookieAccept,
  setAllowCookieReject,
} from 'app/api/cookie';
import ButtonPair from 'app/components/shared/ButtonPair';
import Box from 'app/components/v2/components/Box';
import Button from 'app/components/v2/components/Button';
import Drawer from 'app/components/v2/components/Drawer';
import { useAuthDispatch } from 'app/state/AuthContext/hooks';

import CookieContent from './CookieContent';

// Component Definition
const AllowCookiesInterstitial: FC = () => {
  const { t } = useTranslation('components');
  const [cookiesAccepted, setCookiesAccepted] = useState(areCookiesAccepted());
  const [cookiesRejected, setCookiesRejected] = useState(areCookiesRejected());

  const authDispatch = useAuthDispatch();

  function updateValues() {
    setCookiesAccepted(areCookiesAccepted());
    setCookiesRejected(areCookiesRejected());

    authDispatch({
      payload: {
        areCookiesAllowed: areCookiesAccepted(),
      },
      type: 'updateCookiePermission',
    });
  }

  function handleAccept() {
    setAllowCookieAccept();
    updateValues();
  }

  function handleReject() {
    setAllowCookieReject();
    updateValues();
  }

  return (
    <Drawer
      isOpen={!cookiesAccepted && !cookiesRejected}
      isPaddingDisabled
      position="bottom"
    >
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        padding={4}
      >
        <CookieContent />

        <ButtonPair
          leftButton={(
            <Button
              hierarchy="secondary"
              onClick={handleReject}
            >
              {t('common:decline', 'Decline')}
            </Button>
          )}
          rightButton={(
            <Button onClick={handleAccept}>
              {t('common:accept', 'Accept')}
            </Button>
          )}
        />
      </Box>
    </Drawer>
  );
};

export default AllowCookiesInterstitial;
